export enum enumGATagEventLabel {
  Validations = 'Validations',
  Accept = 'Accept',
  BeginCheckout = 'Begin Checkout',
  VerifyEmail = 'Verify email',
  SetupBusinessProfile = 'Setup My Profile',
  LoginSuccess = 'Login success',
  OBAchMethodGoToForm = 'Go to Form 400',
  WidgetOpen = 'Widget Open',
  WidgetClose = 'Widget Close',
  DripUrlClick = 'Drip Url Click',
  UshipUrlClick = 'uShip Url Click',
  Received = 'Received',
  Sent = 'Sent',
  UserCreate = 'User Create',
  UserLoaded = 'User Loaded',
  UserIdentified = 'User Identified',
  UserRestored = 'User Restored',
  StartFirstScreen = 'Start First Screen',
  SignUpSecondScreen = 'Sign Up Second Screen',
  PageView = 'Page View',
}
